import styled from 'styled-components'

export const ErrorBannerContainer = styled.div`
  margin-bottom: 24px;
`
export const InputContainer = styled.div`
  margin-top: 20px;
`
